import React from 'react';
import { ListBulkActionsContextValue } from './types';

export const ListBulkActionsContext = React.createContext<ListBulkActionsContextValue | null>(null);

export function useListBulkActionsContext(): ListBulkActionsContextValue {
    const context = React.useContext(ListBulkActionsContext);
    if (!context) {
        throw new Error('useListBulkActionsContext must be used within a List');
    }
    return context;
}
